<template>
  <div class="sel-color">
    <div
      v-for="(item,index) in colors"
      :key="index"
      :class="((item.color_name != `white`) ? `color-block` : `color-block white-color-block`)"
      :style="{backgroundImage:`linear-gradient(to bottom,#${item.s_color},#${item.e_color})`}"
      @click="changeIdx(index)"
    >
      <a-icon
        v-if="index == colorsIdx"
        type="check"
        :style="{...item.color_name != 'white' && item.color_name != `grey` && {color:`#ffffff`}}"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "selColor",
  props: {
    colors: Array,
    colorsIdx: { type: Number, default: 0 },
    changeIdx: Function
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
.sel-color {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.color-block {
  width: 28px;
  height: 28px;
  margin-right: 6px;
  margin-bottom: 4px;
  display: inline-block;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.white-color-block {
  border: 1px solid #cccccc;
}
</style>
